import model from "@js/model.js";
import { clearLocationSearch, compareStrings, deaccentAndStripWhitespace, getParameterByName } from "@helpers/utils.js"
import { reactive } from "vue"

import { FiltersLabel } from "@lang/user.js";

export default {
	initFilters(){
		model.pushLang({FiltersLabel});

		model.observables.filterCompLoaded = false;
		model.observables.filterOpenedOnce = false;
		model.observables.filterDisplayed = false;
		model.observables.filterOpening = false;
		model.observables.filterOn = false;

		model.filterPropsShared = reactive({
			searchByNameInput: '',
			onSearchInputClear: () => {
				model.filterPropsShared.searchByNameInput = '';
			},
		});

		model.on('OpenFilter', e => {
			e.dispose();
			var navAttached = e.navAttached;

			this.fetchPreparedGames(() => {
				this.whenComponentReady('GameFilter').then(() => {
					model.observables.filterCompLoaded = true;
					model.dispatchEvent('OpenFilter', {navAttached});
				});
				model.observables.filterOpenedOnce = true;
			});
		});

		if(typeof model.filterActive !== 'boolean') model.filterActive = true;

		model.filterAutoProps = {};

		this.autoActivateFilter({provider: getParameterByName('filterprovider')});
		clearLocationSearch('filterprovider');
	},
	async autoActivateFilter({provider}){
		if(!model.isMobile && provider){
			await this.loadGameProviderConfig();
			let firstProvider = provider.split(',')[0];
			let p = model.providerConfig.find(item => compareStrings(item.id, firstProvider) || compareStrings(item.label, firstProvider));
			if(p?.filter?.categoryID) this.gotoCategory({level1: p.filter.categoryID});
		}

		setTimeout(() => {
			if(provider) model.filterAutoProps.providers = provider;
			if(Object.keys(model.filterAutoProps).length > 0) this.whenGamesReady(() => model.dispatchEvent('OpenFilter'));
		}, 0);
	},
}